<template>
  <div>
    <MountingPortal mountTo="#casesButton">
      <base-button :class="$style.bannerButton" @click="openFilter">Выбрать задачу и&nbsp;отрасль</base-button>
    </MountingPortal>

    <CasesLogo :filtered-industries="filter.industries" :industries="industries" :totalClients="totalClients" />

    <CasesFilter ref="filter" @dataSent="handleData" :industries="industries" :tasks="tasks" />

    <NoFoundItem v-if="!filteredCases.length" @openFilter="openFilter" @clearFilter="clearFilter" />

    <div ref="casesRow" v-else :class="[$style.casesItems, { [$style.casesRowAnimation]: animated }]">
      <case-item
        ref="caseItem"
        v-for="item in filteredCases"
        :cases="item"
        :key="item.id"
        :filtered="filtered"
        @chooseIndustry="chooseIndustry"
      />
      <AnotherCasesCard v-if="isAnotherCasesCardVisible" @clearFilter="clearFilter" />
    </div>
    <base-button :class="$style.showMore" @click="showMoreItems" v-if="!filtered && isMoreButtonVisible"
      >Показать больше кейсов</base-button
    >
  </div>
</template>

<script>
// карточка сброса фильтра
import AnotherCasesCard from './AnotherCasesCard.vue';
// карточка кейса
import CaseItem from './CaseItem.vue';
// фильтр
import CasesFilter from './CasesFilter.vue';
// вывод логотипов
import CasesLogo from './CasesLogo.vue';
// элемент выводится если нет совпадений в фильтре
import NoFoundItem from './NoFoundItem.vue';

import scrollTo from '~scripts/core/scrollTo';
import { BaseButton } from 'huntkit';
import { MountingPortal } from 'portal-vue';

export default {
  name: 'Cases',
  components: {
    AnotherCasesCard,
    BaseButton,
    CaseItem,
    CasesFilter,
    NoFoundItem,
    MountingPortal,
    CasesLogo,
  },
  props: {
    cases: {
      type: Array,
      required: true,
    },
    totalClients: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      animated: false,
      itemsToShow: 10,
      filter: {
        industries: [],
        tasks: [],
      },
    };
  },
  computed: {
    industries() {
      let industries = [];
      this.cases.forEach((item) => {
        item.industries.forEach((industry) => {
          if (!industries.some((elem) => elem.id === industry.id)) {
            industries.push(industry);
          }
        });
      });
      return industries;
    },
    tasks() {
      let tasks = [];
      this.cases.forEach((item) => {
        item.tasks.forEach((task) => {
          if (!tasks.some((elem) => elem.id === task.id)) {
            tasks.push(task);
          }
        });
      });
      return tasks;
    },
    filtered() {
      return Boolean(this.filter.industries.length || this.filter.tasks.length);
    },
    filteredCases() {
      const { industries, tasks } = this.filter;

      if (!this.filtered) {
        return this.cases.slice(0, this.itemsToShow);
      }

      return this.cases.filter((item) => {
        let visible = true;

        if (industries.length) {
          visible &= item.industries.some((item) => {
            return industries.map((item) => item.id).includes(item.id);
          });
        }

        if (tasks.length) {
          visible &= item.tasks.some((item) => {
            return tasks.map((item) => item.id).includes(item.id);
          });
        }

        return visible;
      });
    },
    isMoreButtonVisible() {
      return this.itemsToShow <= this.cases.length;
    },
    isAnotherCasesCardVisible() {
      return this.filtered && 0 < this.filteredCases.length;
    },
  },
  watch: {
    filteredCases() {
      this.animated = true;
      setTimeout(() => (this.animated = false), 600);
    },
  },
  methods: {
    chooseIndustry(industry) {
      const casesSection = document.querySelector('#casesApp');
      this.scrollTo(casesSection, 90);

      setTimeout(() => {
        this.filter = { ...this.filter, tasks: [], industries: [industry] };
        this.$refs.filter.filter = { industries: [industry], tasks: [] };
      }, 300);
    },
    handleData(data) {
      const casesSection = document.querySelector('#casesApp');

      this.scrollTo(casesSection, 90);
      setTimeout(() => {
        this.filter = Object.assign(this.filter, data);
      }, 400);
    },
    openFilter() {
      this.$refs.filter.toggleDropdown();
    },
    clearFilter() {
      this.$refs.filter.clearFilter();
    },
    scrollTo(el, offset, duration = 600) {
      const contentRect = el.getBoundingClientRect();
      const y = contentRect.top + window.scrollY - offset;
      scrollTo(y, { duration: duration });
    },
    showMoreItems() {
      let showedItem = this.itemsToShow;
      this.itemsToShow += 10;

      this.$nextTick(() => {
        this.animated = false;

        this.$refs.caseItem.forEach((item, index) => {
          if (showedItem <= index && index <= this.itemsToShow) {
            item.$el.classList.add('showMoreAnimation');
          }
        });
      });
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.bannerButton {
  @include mixins.font(1.6rem, 1);

  height: 44px;
  padding: 1.4rem 2.4rem;
  margin-top: 2rem;
  box-shadow: unset;

  @include mixins.media(md) {
    @include mixins.font(2rem, 1);

    height: 52px;
    margin-top: 2rem;
    background-color: #1d1d1f;

    @include mixins.hover {
      &:hover {
        background-color: #323235;
      }
    }
  }
}

.casesItems {
  @include mixins.media(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  @include mixins.media(md) {
    gap: 80px 20px;
  }

  @include mixins.media(lg) {
    gap: 116px 20px;
    grid-template-columns: repeat(3, 1fr);
  }

  @include mixins.media(xl) {
    gap: 116px 24px;
  }
}

.showMore {
  @include mixins.size(100%, 57px);

  margin-top: 40px;
  background-color: rgba(235, 237, 242, 0.6);
  border-radius: 6px;
  box-shadow: unset;
  color: #1d1d1f;
  box-shadow: unset !important;

  @include mixins.hover {
    &:hover {
      background-color: rgba(235, 237, 242, 1);
    }
  }

  @include mixins.media(md) {
    @include mixins.size(100%, 66px);
    @include mixins.font(2rem, 1.1);

    padding: 22px;
    margin-top: 64px;
    border-radius: 11px;
  }
}

@keyframes casesRowAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.casesRowAnimation {
  animation: casesRowAnimation 1s forwards;
}
</style>

<style scoped>
@keyframes showMoreAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.showMoreAnimation {
  animation: showMoreAnimation 1s ease forwards;
}
</style>
